import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'AVGS',
  sections: {
    Kostenträger: {
      fields: [
        { id: 'Kostenträger.Behörde', control: 'text-or-date' },
        { id: 'Kostenträger.Standort', control: 'text-or-date' },
      ],
    },
    Teilnehmer: {
      fields: [
        { id: 'Teilnehmer.Anrede', control: 'select', options: ['Herr', 'Frau'] },
        { id: 'Teilnehmer.Vorname', control: 'text-or-date' },
        { id: 'Teilnehmer.Nachname', control: 'text-or-date' },
        { id: 'Teilnehmer.Kundennummer', control: 'text-or-date' },
        { id: 'Teilnehmer.AVGS-Nummer (laufende Nummer)', control: 'text-or-date' },
      ],
    },
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Maßnahmeinhalt (Gruppenmaßnahme)', control: 'text', dictation: true },
        { id: 'Maßnahme.Maßnahmeinhalt (Einzelmaßnahme)', control: 'text', dictation: true },
        { id: 'Maßnahme.Maximale Maßnahmedauer', control: 'text-or-date' },
        { id: 'Maßnahme.Gültigkeit Beginn', control: 'text-or-date' },
        { id: 'Maßnahme.Gültigkeit Ende', control: 'text-or-date' },
        { id: 'Maßnahme.Beschränkungen', control: 'text', dictation: true },
        { id: 'Maßnahme.Zeitlicher Umfang (Kategorie)', control: 'select', options: ['Vollzeit', 'Teilzeit'] },
        { id: 'Maßnahme.Zeitlicher Umfang (max UE)', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
